export const Roles = {
  Admin: 'admin',
};
